<template>
  <div class="flex flex-col gap-2 lg:gap-4">
    <div class="font-bold">
      {{ title }}
    </div>
    <slot name="top" />
    <div>
      <ul class="list-none flex flex-col gap-y-3 my-1">
        <FooterLinkItem
          v-for="link in links"
          :key="link.name || link.translationKey"
          :link="link"
          :data-gtm="link.gtmId"
        />
      </ul>
    </div>
    <slot name="bottom" />
  </div>
</template>
<script lang="ts">

import type { FooterLink } from '~~/types/cms/Footer/FooterLink/FooterLink';
import { instanceOfFooterLink } from '~~/types/cms/Footer/FooterLink/instanceOfFooterLink';
import { LINK_TYPE } from '~~/types/components/Link/LinkType';

export default defineComponent({
  name: 'FooterLinkColumn',

  props: {
    title: {
      type: String,
      required: true,
    },
    links: {
      type: Array as PropType<FooterLink[]>,
      required: true,
      validator: (links: FooterLink[]) => {

        if (links.length === 0) {

          return false;

        }

        return links.every(link => instanceOfFooterLink(link));

      },
    },
  },
  setup() {

    return {
      LINK_TYPE,
    };

  },
});

</script>
